import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
export const fetchPrivilegesSuccess = createAction(`${reduxKey}.PRIVILEGES.FETCH.SUCCESS`, (payload)=>payload);
